export function Uncommissioned (apiJson) {
  const source = apiJson?.data?.data?.sourceDevices
  let arrUncomm = []
  if (source)
    arrUncomm = source.filter(item => !item?.TargetAC)
  return arrUncomm
}
export function Commissioned (apiJson) {
  const source = apiJson?.data?.data?.sourceDevices
  let result = []
  if (source)
    result = source.filter(item => undefined !== item?.TargetAC)
  return result
}